import { Directive, Input, ElementRef, AfterViewInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';

declare var jQuery: any;

@Directive({
  selector: '[appResizable]'
})
export class ResizableDirective implements AfterViewInit {
  @Input() isFlexVertical: boolean;
  @Input() isFlexHorizontal: boolean;
  @Input() handles: string;
  @Input() applyChild: boolean;
  @Input() child: string;
  @Input() subtract: string;
  @Input() nextApplyChild: boolean;
  @Input() nextChild: string;
  @Input() nextSubtract: string;
  @Input() disabled: boolean;
  @Input() maxWidth: string;
  @Input() maxHeight: string;
  @Input() minWidth: string;
  @Input() minHeight: string;

  @Output() emitterResize: EventEmitter < any > = new EventEmitter < any > ();

  constructor(private element: ElementRef) {  }

  verticalFlex (event, ui) {
    const parent = ui.element.parent();
    const netx = ui.element.next();
    const width = ui.element.width() / parent.width() * 100;

    ui.element.css({
      width: width + '%'
    });

    netx.css({
      width: (100 - width) + '%'
    });
  }

  horizontalFlex (event, ui) {
    const self = this;
    const parent = ui.element.parent();
    const netx = ui.element.next();
    const height = ui.element.height() / parent.height() * 100;

    ui.element.css({
      height: height + '%'
    });

    if (self.nextApplyChild && self.nextChild) {
      const subtract = self.nextSubtract ? jQuery(self.nextSubtract,  ui.element.next()).height() : 0;
      const grid = jQuery(self.nextChild,  ui.element.next());
      grid.css({
        height: `calc(100% - ${subtract}px)`
      });
    }

    netx.css({
      height: (100 - height) + '%'
    });
  }

  getHandles() {
    const handles = [];
    if (this.isFlexVertical || this.isFlexHorizontal) {
      if (this.isFlexVertical) {
        handles.push('e');
      }
      if (this.isFlexHorizontal) {
        handles.push('s');
      }
      return handles.join(',');
    } else {
      if (this.handles) {
        return this.handles;
      } else {
        return 'e,s';
      }
    }
  }

  ngAfterViewInit() {

    if (!this.disabled) {
      const that = this;
      jQuery( this.element.nativeElement )
      .css({
        maxHeight : that.maxHeight ? that.maxHeight : 'auto',
        minHeight : that.minHeight ? that.minHeight : 'auto',
        maxWidth : that.maxWidth ? that.maxWidth : 'auto',
        minWidth : that.minWidth ? that.minWidth : 'auto'
      }).resizable({
        handles: that.getHandles(),
        create: function (event, ui) {

          if (that.isFlexVertical) {
            jQuery('.ui-resizable-e', that.element.nativeElement)
            .dblclick(function () {
              const elem = jQuery(that.element.nativeElement);
              elem.css({
                width: 25 + 'px'
              });
              that.verticalFlex(true, {element:  elem});
              jQuery(elem[0].lastElementChild).addClass('column-hide');
            });
          }

          if (that.isFlexHorizontal) {
            jQuery('.ui-resizable-s', that.element.nativeElement)
            .dblclick(function () {
              const elem = jQuery(that.element.nativeElement);
              elem.css({
                height: 25 + 'px'
              });
              that.horizontalFlex(true, {element:  elem});
              jQuery(elem[0].lastElementChild).addClass('column-hide-hotizontal');
            });
          }

        },
        resize: function (event, ui) {
          if (that.isFlexVertical) {
            that.verticalFlex(event, ui);
          }
          if (that.isFlexHorizontal) {
            that.horizontalFlex(event, ui);
          }

          if (that.applyChild && that.child) {
            const subtract = that.subtract ? jQuery(that.subtract,  ui.element ).height() : 0;
            const grid = jQuery(that.child,  ui.element );
            grid.css({
              height: `calc(100% - ${subtract}px)`
            });
          }

          ui.element.children().css({
            opacity: ui.element.width() <= 100 || ui.element.height() <= 100 ? 0 : 1
          });
          jQuery(ui.element[0].lastElementChild).css({
            opacity: 1
          });
          if (ui.element.width() <= 100) {
            jQuery(ui.element[0].lastElementChild).addClass('column-hide');
          } else {
            jQuery(ui.element[0].lastElementChild).removeClass('column-hide');
          }

          if (ui.element.height() <= 100) {
            jQuery(ui.element[0].lastElementChild).addClass('column-hide-hotizontal');
          } else {
            jQuery(ui.element[0].lastElementChild).removeClass('column-hide-hotizontal');
          }

          that.emitterResize.emit({event: event, ui: ui});
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/resizable/resizable.directive.ts